<template>
    <div class="modal-content card dashboardGuidedTour">
        <div class="card-content">
            <h1 class="title is-2">Build a Dashboard That Fits</h1>

            <section class="dashboardGuidedTour__description mt-2 has-text-centered">
                <p>
                    Next, choose a starting layout for your dashboard. You can still customize your widgets,
                    move cards around, and update the layout later.
                </p>
            </section>
        </div>

        <div class="card-footer align-items-end">
            <div class="card-footer-item">
                <a href="#" @click.prevent="$emit('back')">
                    <icon-text icon="angle-left" position="is-left" class="is-mobile" dense>Previous</icon-text>
                </a>
            </div>

            <div class="card-footer-item">
                <a href="#" @click.prevent="$emit('next')">
                    <icon-text icon="angle-right" position="is-right" class="is-mobile" dense>Next</icon-text>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import IconText from '@/components/IconText.vue';

export default {
    name: 'DashboardGuidedTourStepTwo',

    components: { IconText },

    emits: ['back', 'next'],
};
</script>
